import type { Money } from '@betterment/core';

export const ANNUAL_FOUR_OH_ONE_K_CONTRIBUTION_FREQUENCY = 'ANNUAL';

export interface TaxYear {
  __typename?: string;
  id: string;
  year: number;
  fourOhOneKContributionLimit: Money;
  isEligibleForFourOhOneKContributionCatchUp: boolean;
}

export interface FourOhOneKContributionsProjection {
  __typename?: string;
  id: string;
  total: Money;
}

export interface FourOhOneKContributions {
  __typename?: string;
  id: string;
  amount: Money;
  projection?: FourOhOneKContributionsProjection | null;
}

export interface AnnualFourOhOneKContributions {
  __typename?: string;
  taxYear: TaxYear;
  result: FourOhOneKContributions;
}

export interface EmployerFourOhOneKContributionsProjection {
  __typename?: string;
  id: string;
  total: Money;
}

export interface EmployerFourOhOneKContributions {
  __typename?: string;
  id: string;
  amount: Money;
  projection?: EmployerFourOhOneKContributionsProjection | null;
}

export interface EmployerFourOhOneKContributionsResult {
  __typename?: string;
  id: string;
  thisYear: EmployerFourOhOneKContributions;
}

export interface EmployerFourOhOneKContributionConfig {
  __typename?: string;
  id: string;
  frequency: string;
  limit: Money;
}

export interface SoloFourOhOneKPlan {
  __typename?: string;
  id: string;
}

export interface Employer {
  __typename?: string;
  id: string;
  name: string;
  contributionConfig?: EmployerFourOhOneKContributionConfig | null;
  fourOhOneKContributions?: EmployerFourOhOneKContributionsResult | null;
  soloFourOhOneKPlan?: SoloFourOhOneKPlan | null;
}

export interface EmployeeFourOhOneKContributionsResult {
  __typename?: string;
  id: string;
  thisYear: AnnualFourOhOneKContributions;
}

export type EmployersResult = Employer[];

export interface FourOhOneKContributionsQueryResult {
  employeeContributions?: EmployeeFourOhOneKContributionsResult | null;
  employers?: EmployersResult | null;
}
